/* eslint-disable react/no-multi-comp */
import React from 'react';

import { Row, Col } from '@app/ui';
import GenderBreakdownTiles from './GenderBreakdownTiles';
import GenderBreakdownByGame from './GenderBreakdownByGame';

const GenderBreakdown = () => {
    return (
        <Row gutter={16} className="invenue-flex-container">
            <Col md={24}>
                <p className="-m-b-1">
                    Attendance Distribution by Gender by Event
                </p>
            </Col>
            <Col md={12}>
                <GenderBreakdownByGame />
            </Col>
            <Col md={12}>
                <GenderBreakdownTiles />
            </Col>
        </Row>
    );
};

export default GenderBreakdown;
